import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PrimaryButton, Text } from 'DVWebNodeUI'
import * as st from './pageBlock.module.scss'

export interface IPageBlockProps {
  model?: WpsRuntime.atv.wps.BlockedPageModelProps
}

export const PageBlock = ({ model }: IPageBlockProps) => {
  if (!model) {
    return null
  }

  return <div className={st.container}>
    <div className={st.content}>
      <p className={st.primaryMessage}><Text string={model.message} /></p>
      <p><Text string={model.secondaryMessage} /></p>
      <div className={st.actions}>
        {model.primaryActionText &&
          <PrimaryButton href={model.primaryActionLink}>
              <Text string={model.primaryActionText} />
          </PrimaryButton>
        }
        <span className={st.secondaryAction}><Text string={model.secondaryAction} /></span>
      </div>
    </div>
  </div>
}
